const UnsubscribeSuccess = (): React.ReactElement => {
  return (
    <>
      <h1 className="mb-2 text-11xl">Your BT newsletter subscriptions</h1>

      <p className="text-gray-900">
        Your BT newsletter subscriptions have been successfully updated.
      </p>
    </>
  );
};

export default UnsubscribeSuccess;
